import { render } from "./Button.vue?vue&type=template&id=2b5f7cfa&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=2b5f7cfa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b5f7cfa"

export default script